require('./bootstrap');
import EmailVerification from "./Auth/Email/EmailVerification.js";
import LoginIndex from "./Auth/login.js";
import PasswordReset from "./Auth/Password/PasswordReset.js";
import PasswordUpdate from "./Auth/Password/PasswordUpdate.js";
import RegisterIndex from "./Auth/register.js";
import Scheduler from "./libs/scheduler.js";
import ModeratorRightsTime from "./Moderator/Rights/ModretorRightsTime.js";
// import AddPaymentMethod from "./plans/AddPaymentMethod.js";
// import virtualBackground from "./libs/virtuaBackground.js";
// import LocalRecording from "./libs/local-recording.js";
import CancelPlan from "./plans/CancelPlan.js";
import PlanIndex from "./plans/Index.js";
import PlanList from "./plans/List.js";
import PlanTeam from "./plans/Team.js";
import OutOfHours from "./room/OutOfHours.js";

/***
 *  must be added on another main.js
 *
 */

// mark a select as checked with a class
$('select').on('change', e => {
    if($(e.currentTarget).val()) {
        $(e.currentTarget).addClass('option-selected')
    } else {
        $(e.currentTarget).removeClass('option-selected')
    }
})

if(document.querySelector('.birthdate')) {
    $(".birthdate").flatpickr({
        dateFormat: 'm/d/Y',
        static: true,
        defaultDate: new Date('01/01/2000'),
    });

}

if(document.querySelector('#videoSpace'))      require('./libs/roomnew')

/**
 *      Plans
 */
if(document.querySelector('#subscription-form'))                    new PlanIndex()
if(document.querySelector('#plan-list-card'))                       new PlanList()
if(document.querySelector('#cancel-plan-modal-btn'))                new CancelPlan()

if(document.querySelector('#verify-email-btn'))                     new EmailVerification() 
if(document.querySelector('#billing-container-main')) require("./billing/Index");
/**
 *
 *      AUTH
 */

if(document.querySelector('#login-form'))                           new LoginIndex()
if(document.querySelector('#register-form'))                        new RegisterIndex()

// if(document.querySelector('#new-payment-method-card-element'))      new AddPaymentMethod()

/**
 *      Room
 *
 */

// if(document.querySelector('#kinoRecordingBtn'))                  new LocalRecording()

// change password
if(document.querySelector('#reset-password-form'))                  new PasswordReset()
if(document.querySelector('#password-update-form'))                 new PasswordUpdate()
if(document.querySelector('#profile-container')){
     let schedulerClass=new Scheduler()
     schedulerClass.init();
    }
// Moderator Rights
if(document.querySelector('#moderator_rights_event_start_time'))    new ModeratorRightsTime()

/**
 * Out of hours javascript
 * 
*/
if(document.querySelector('#outOfHours-container'))                 new OutOfHours()

